import Button from 'components/actions/Button';
import Dialog from 'components/overlays/Dialog';
import { useSelector } from 'react-redux';
import { getShowExitTeamActionDialog } from 'store/slices/settingsPageSlice';

interface FooterProps {
    id: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const Footer = ({ id, onConfirm, onCancel }: FooterProps) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid={`system-admin-dialog-form-cancel-btn-${id}`} onClick={onCancel}>
            No, back to editing
        </Button>
        <Button
            className='btn btn-danger'
            data-testid={`system-admin-dialog-form-cancel-btn-${id}`}
            onClick={onConfirm}
        >
            Yes, cancel
        </Button>
    </div>
);

interface Props {
    id: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ExitTeamActionDialog = ({ id, onConfirm, onCancel }: Props) => {
    const showExitTeamActionDialog = useSelector(getShowExitTeamActionDialog);
    return (
        <Dialog
            data-testid={`exit-action-confirm-dialog-${id}`}
            show={showExitTeamActionDialog}
            title='Are you sure you want to cancel?'
            size='sm'
            footer={<Footer id={id} onCancel={onCancel} onConfirm={onConfirm} />}
            body={
                <p className='ExitActionDialog__message'>
                    Your changes will be lost and we won’t be able to recover your inputs.
                </p>
            }
            onClose={onCancel}
            showCloseButton
        />
    );
};

export default ExitTeamActionDialog;
